import api from './api';

export const dashboardService = {
  getStats: async () => {
    const response = await api.get('/dashboard/stats');
    return response.data;
  },

  getMonthlySales: async (params = {}) => {
    const response = await api.get('/dashboard/monthly-sales', { params });
    return response.data;
  },

  getExpenseBreakdown: async () => {
    const response = await api.get('/dashboard/expense-breakdown');
    return response.data;
  },

  getTopBrands: async () => {
    const response = await api.get('/dashboard/top-brands');
    return response.data;
  },

  getInventoryStatus: async () => {
    const response = await api.get('/dashboard/inventory-status');
    return response.data;
  },
};
